export default __webpack_public_path__ + "static/media/mobile_feeding_status_en.e48f934b.png";